import { injectable, inject } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import * as Api from '@/app/state-serialization/api'
import { PracticeSessionState } from '../../domain'
import { QuizSessionNavigationStateProtoMessage,
  QuizSessionQuestionStateProtoMessage,
  QuizSessionQuestionTimeStateProtoMessage,
  QuizSessionNavigationStateProtobufMapper,
  QuizSessionQuestionStatesProtobufMapper,
  QuizSessionQuestionTimesStateProtobufMapper} from '@/app/quiz-session/tracking/serialization/api';

@injectable()
export class PracticeSessionStateProtobufSerializer implements Api.StateSerializationPlugin<PracticeSessionState> {

  key = { id: 9, name: { ns: 'suspend-data', name: 'quiz-session-practice' },
          format: 'protobuf' }

  constructor(
    @inject(QuizSessionNavigationStateProtobufMapper)
    private navigationMapper: QuizSessionNavigationStateProtobufMapper,
    @inject(QuizSessionQuestionStatesProtobufMapper)
    private answerMapper: QuizSessionQuestionStatesProtobufMapper,
    @inject(QuizSessionQuestionTimesStateProtobufMapper)
    private questionTimeMapper: QuizSessionQuestionTimesStateProtobufMapper) {

  }

  serialize(data: PracticeSessionState): Result<Uint8Array, Api.SerializerError> {

    const message = new PracticeSessionStateProtoMessage({
      questionIds: data.questionIds,
      navigation: this.navigationMapper.map(data.navigation),
      answers: this.answerMapper.map(data.questionStates),
      questionTimes: this.questionTimeMapper.map(data.questionTimes),
      levelBefore: data.levelBefore
    })

    return ProtobufSerializer.serialize<PracticeSessionStateProtoMessage>(message,
                                                                          PracticeSessionStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<PracticeSessionState, Api.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<PracticeSessionStateProtoMessage>(content,
                                                                                     PracticeSessionStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value

    const result: PracticeSessionState = {
      questionIds: message.questionIds,
      navigation: this.navigationMapper.deserialize(message.navigation),
      questionStates: this.answerMapper.unmap(message.answers),
      questionTimes: this.questionTimeMapper.unmap(message.questionTimes),
      levelBefore: message.levelBefore      
    }
    return ok(result)
  }
}

@Type.d('PracticeSessionStateProtoMessage')
class PracticeSessionStateProtoMessage extends Message<PracticeSessionStateProtoMessage> {

  @Field.d(1, 'uint32', 'optional', 1)
  public schemaVersion: number

  @Field.d(2, 'string', 'repeated')
  questionIds: string[]

  @Field.d(3, QuizSessionNavigationStateProtoMessage)
  navigation: QuizSessionNavigationStateProtoMessage

  @Field.d(4, QuizSessionQuestionStateProtoMessage, 'repeated')
  answers: QuizSessionQuestionStateProtoMessage[]

  @Field.d(5, QuizSessionQuestionTimeStateProtoMessage, 'repeated')
  questionTimes: QuizSessionQuestionTimeStateProtoMessage[]

  @Field.d(6, 'float', 'optional', 0)
  levelBefore: number
}

